import { useEffect } from "react";
import { useSettings } from "../context/SettingsContext";

const has = (v) => typeof v === "string" && v.trim().length > 0;

export default function SiteMeta() {
  const { settings } = useSettings();
  useEffect(() => {
    if (has(settings.site_title)) {
      document.title = settings.site_title;
    }
    if (has(settings.site_description)) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", settings.site_description);
    }
  }, [settings.site_title, settings.site_description]);
  return null;
}
